import React from 'react';
import classnames from 'classnames';
import CheckCircle from '@mui/icons-material/CheckCircle';

import { registerField } from 'core/forms';

import { Typo } from 'uikit/content';
import { createIconComponent } from 'uikit/icons';

import styles from '../styles/formFieldRadioCards.module.scss';

const FormFieldRadioCards = ({
  className,
  fieldId,
  schema,
  updateField,
  value,
}) => (
  <div className={classnames(styles.element, className)}>
    {schema.options.map((option) => {
      const schemaValue = option.value;
      const id = `${fieldId}-${schemaValue}`;
      const isSelected = value === schemaValue;

      return (
        <div
          className={classnames(styles.option, isSelected && styles.isSelected)}
          key={schemaValue}
        >
          <input
            checked={isSelected}
            className={styles.input}
            onChange={() => updateField(schemaValue)}
            id={id}
            type="radio"
            value={value === null ? '' : value}
          />
          <label className={styles.label} htmlFor={id}>
            {isSelected && (
              <CheckCircle className={styles.checkCircle} sx={{ height: 20, width: 20 }} />
            )}
            {createIconComponent({ icon: option.icon, className: styles.icon, size: 38 })}
            <Typo className={styles.title} element="h5" weight="medium">
              {option.label}
            </Typo>
            <Typo className={styles.body} variant="b01">{option.description}</Typo>
          </label>
        </div>
      );
    })}
  </div>
);

registerField('RadioCards', React.memo(FormFieldRadioCards));

export default React.memo(FormFieldRadioCards);
